export { default as Img200 } from './processed/200/queen.jpg';
export { default as Img400 } from './processed/400/queen.jpg';
export { default as Img600 } from './processed/600/queen.jpg';
export { default as Imgthumb } from './processed/thumb/queen.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/queen.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/queen.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      211,
      64,
      87
    ],
    "_population": 771,
    "_hsl": [
      0.9739229024943311,
      0.6255319148936169,
      0.5392156862745098
    ]
  },
  "LightVibrant": {
    "_rgb": [
      216,
      218,
      126
    ],
    "_population": 2353,
    "_hsl": [
      0.17028985507246375,
      0.5542168674698795,
      0.6745098039215687
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      94,
      59,
      42
    ],
    "_population": 1886,
    "_hsl": [
      0.05448717948717949,
      0.3823529411764706,
      0.26666666666666666
    ]
  },
  "Muted": {
    "_rgb": [
      147,
      116,
      68
    ],
    "_population": 1744,
    "_hsl": [
      0.10126582278481015,
      0.3674418604651163,
      0.42156862745098034
    ]
  },
  "LightMuted": {
    "_rgb": [
      231,
      227,
      204
    ],
    "_population": 520,
    "_hsl": [
      0.14197530864197522,
      0.35999999999999976,
      0.8529411764705883
    ]
  },
  "DarkMuted": {
    "_rgb": [
      71,
      47,
      38
    ],
    "_population": 1260,
    "_hsl": [
      0.04545454545454547,
      0.30275229357798167,
      0.21372549019607845
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/queen.js